import classNames from "classnames";
import type { NavLinkProps } from "react-router-dom";
import { NavLink } from "react-router-dom";
import styles from "./styles.module.css";

interface Props extends NavLinkProps {
  activeClassName: string;
}

export const AppNavLink: React.FC<Props> = ({
  activeClassName,
  className,
  children,
  to,
  ...props
}) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        classNames(styles.link, className, { [activeClassName]: isActive })
      }
      {...props}
    >
      {children}
    </NavLink>
  );
};
